<template>
    <div>
        <h2>Worldwide News</h2>
        <h3>Sentiment Analysis</h3>
        <v-content>
            <v-row>
                <v-col cols="2" :key="sentiment.sentiment" v-for="sentiment in SentimentAnalysis">
                    <p :class="sentiment.sentiment">{{ sentiment.percentage }}%</p>
                    <h4 class="sentiment-title">{{ sentiment.sentiment }}</h4>
                </v-col>
            </v-row>
        </v-content>
        <v-divider class="my-5"></v-divider>
        <h3>Top Stories</h3>
        <v-content>
            <v-row>
                <v-col v-for="(news, i) in TopNews" :key="i" cols="12">
                    <v-card light @click="goToNews(news.newsSource)" outlined>
                        <div class="d-flex flex-no-wrap justify-space-between">
                            <div>
                                <v-card-title>
                                    <h3>{{ news.title }}</h3>
                                    <v-spacer style="max-width: 1vw"></v-spacer>
                                    <v-chip color="#FFF75F" text-color="#6C7079"> {{ news.sentiment }} </v-chip>
                                </v-card-title>
                                <v-card-text>
                                    <p class="news-overview">{{ news.overview }}</p>
                                    <p>By {{ news.provider }}</p>
                                </v-card-text>
                            </div>
                            <v-avatar class="ma-3" size="125" tile >
                                <v-img :src="news.imageSrc"></v-img>
                            </v-avatar>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-content>
        <button>View more news</button>
    </div>
</template>

<script>
    export default {
        name: "NewsStories",
        created() {
          this.formatNews();
        },
        props: {
            TopNews: Array,
            SentimentAnalysis: Array,
        },
        methods: {
            goToNews(url) {
                window.open(url, '_blank');
            },
            formatNews() {
                this.TopNews.forEach((news) => {
                    if(news.overview.length > 300)
                        news.overview = `${news.overview.substr(0, 300)}...`;
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../global";

    .sentiment-title {
        font-size: 20px;
    }
    .news-overview {
        font-size: 17px !important;
        color: $text-color !important;
    }

    $sentiments: (
            Positive: $primary-color,
            Neutral: $text-color,
            Negative: $red-color,
    );

    @each $sentiment, $sentimentColor in $sentiments {
        .#{$sentiment} {
            color: $sentimentColor;
            font-size: 40px;
        }
    }
</style>
